/* eslint-disable no-unused-vars */
// import React from 'react';
// import styled from 'styled-components';
// import { lowerCase } from 'lodash';
// import { lazy } from '@vdx/loadable-component';
// import userStore from '@vdx-platform/core/user/store';
// import Drawer from '@vdx-platform/core/shared/app/menu/Drawer';
// import { fade } from '@material-ui/core/styles/colorManipulator';
// import MenuItem from '@vdx-platform/core/shared/app/menu/Drawer/MenuItem';

// const Navigation = lazy(props => import(`./${props.userType}/Drawer`));

// const MenuContent = styled(({ className }) => {
//   const userType = userStore.useStoreState(state => state.type);
//   return (
//     <Navigation
//       key={lowerCase(userType)}
//       userType={lowerCase(userType)}
//       translationNamespace="admin-layout"
//       className={className}
//     />
//   );
// })`
//   ${Drawer.Menu.Divider} {
//     background-color: ${({ theme }) =>
//       fade(theme.palette.primary.light, theme.palette.action.focusOpacity)};
//   }
//   ${Drawer.Menu.Entry} {
//     background-color: ${({ theme }) => theme.palette.primary.contrastText};
//     color: ${({ theme }) => theme.palette.primary.main};
//     &:hover,
//     &:focus {
//       color: ${({ theme }) => theme.palette.primary.main};
//     }
//   }
//   ${Drawer.Menu} {
//     & [class*='--active'] {
//       background-color: ${({ theme }) => theme.palette.primary.main};
//       color: ${({ theme }) => theme.palette.primary.contrastText};
//       ${MenuItem.Text} {
//         font-weight: bold;
//       }
//     }
//   }
//   ${Drawer.Menu.Entry.SubMenu} {
//     background-color: ${({ theme }) => theme.palette.primary.light};
//     color: ${({ theme }) => theme.palette.primary.contrastText};
//     & [class*='--active'] {
//       background-color: ${({ theme }) => theme.palette.primary.main};
//       color: ${({ theme }) => theme.palette.primary.contrastText};
//       ${MenuItem.Text} {
//         font-weight: bold;
//       }
//     }
//   }
// `;

// export default MenuContent;
import React, { useCallback, useState } from 'react';

import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';

import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { Button, Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { navigate } from '@vdx/hookrouter';

const DocIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M12 11.25V17.25M15 14.25H9M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DocumentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 12H12.75M9 15H12.75M9 18H12.75M15.75 18.75H18C18.5967 18.75 19.169 18.5129 19.591 18.091C20.0129 17.669 20.25 17.0967 20.25 16.5V6.108C20.25 4.973 19.405 4.01 18.274 3.916C17.9 3.88498 17.5256 3.85831 17.151 3.836M17.151 3.836C17.2174 4.05109 17.2501 4.27491 17.25 4.5C17.25 4.69891 17.171 4.88968 17.0303 5.03033C16.8897 5.17098 16.6989 5.25 16.5 5.25H12C11.586 5.25 11.25 4.914 11.25 4.5C11.25 4.269 11.285 4.046 11.35 3.836M17.151 3.836C16.868 2.918 16.012 2.25 15 2.25H13.5C13.0192 2.25011 12.5511 2.40414 12.1643 2.68954C11.7774 2.97493 11.492 3.3767 11.35 3.836M11.35 3.836C10.974 3.859 10.6 3.886 10.226 3.916C9.095 4.01 8.25 4.973 8.25 6.108V8.25M8.25 8.25H4.875C4.254 8.25 3.75 8.754 3.75 9.375V20.625C3.75 21.246 4.254 21.75 4.875 21.75H14.625C15.246 21.75 15.75 21.246 15.75 20.625V9.375C15.75 8.754 15.246 8.25 14.625 8.25H8.25ZM6.75 12H6.758V12.008H6.75V12ZM6.75 15H6.758V15.008H6.75V15ZM6.75 18H6.758V18.008H6.75V18Z"
      stroke="#242424"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArchivesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.25 7.5L19.625 18.132C19.5913 18.705 19.3399 19.2436 18.9222 19.6373C18.5045 20.031 17.952 20.2502 17.378 20.25H6.622C6.04796 20.2502 5.49555 20.031 5.07783 19.6373C4.66011 19.2436 4.40868 18.705 4.375 18.132L3.75 7.5M10 11.25H14M3.375 7.5H20.625C21.246 7.5 21.75 6.996 21.75 6.375V4.875C21.75 4.254 21.246 3.75 20.625 3.75H3.375C2.754 3.75 2.25 4.254 2.25 4.875V6.375C2.25 6.996 2.754 7.5 3.375 7.5Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TeamsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.059 15.521C17.5268 15.2015 18.0755 15.0211 18.6415 15.0004C19.2076 14.9798 19.768 15.1199 20.2578 15.4044C20.7476 15.689 21.1468 16.1064 21.4093 16.6084C21.6718 17.1104 21.7868 17.6764 21.741 18.241C20.5412 18.6603 19.2668 18.8235 18 18.72C17.9961 17.5866 17.6697 16.4768 17.059 15.522C16.5169 14.6718 15.7691 13.972 14.8848 13.4875C14.0005 13.003 13.0083 12.7493 12 12.75C10.9918 12.7495 9.99981 13.0032 9.11571 13.4877C8.23162 13.9723 7.48399 14.6719 6.94199 15.522M17.999 18.719L18 18.75C18 18.975 17.988 19.197 17.963 19.416C16.1483 20.4571 14.0921 21.0033 12 21C9.82998 21 7.79299 20.424 6.03699 19.416C6.01128 19.1846 5.99892 18.9519 5.99999 18.719M5.99999 18.719C4.73361 18.8263 3.45989 18.6637 2.26099 18.242C2.21534 17.6776 2.33038 17.1117 2.59281 16.6099C2.85525 16.1081 3.25435 15.6908 3.74399 15.4063C4.23362 15.1218 4.79378 14.9817 5.3597 15.0021C5.92563 15.0226 6.4742 15.2028 6.94199 15.522M5.99999 18.719C6.00358 17.5857 6.33161 16.4769 6.94199 15.522M15 6.75C15 7.54565 14.6839 8.30871 14.1213 8.87132C13.5587 9.43393 12.7956 9.75 12 9.75C11.2043 9.75 10.4413 9.43393 9.87866 8.87132C9.31606 8.30871 8.99999 7.54565 8.99999 6.75C8.99999 5.95435 9.31606 5.19129 9.87866 4.62868C10.4413 4.06607 11.2043 3.75 12 3.75C12.7956 3.75 13.5587 4.06607 14.1213 4.62868C14.6839 5.19129 15 5.95435 15 6.75ZM21 9.75C21 10.0455 20.9418 10.3381 20.8287 10.611C20.7156 10.884 20.5499 11.1321 20.341 11.341C20.132 11.5499 19.884 11.7157 19.611 11.8287C19.338 11.9418 19.0455 12 18.75 12C18.4545 12 18.1619 11.9418 17.8889 11.8287C17.616 11.7157 17.3679 11.5499 17.159 11.341C16.9501 11.1321 16.7843 10.884 16.6713 10.611C16.5582 10.3381 16.5 10.0455 16.5 9.75C16.5 9.15326 16.737 8.58097 17.159 8.15901C17.581 7.73705 18.1532 7.5 18.75 7.5C19.3467 7.5 19.919 7.73705 20.341 8.15901C20.7629 8.58097 21 9.15326 21 9.75ZM7.49999 9.75C7.49999 10.0455 7.44179 10.3381 7.32871 10.611C7.21564 10.884 7.04991 11.1321 6.84098 11.341C6.63204 11.5499 6.38401 11.7157 6.11102 11.8287C5.83804 11.9418 5.54546 12 5.24999 12C4.95451 12 4.66193 11.9418 4.38895 11.8287C4.11596 11.7157 3.86793 11.5499 3.65899 11.341C3.45006 11.1321 3.28433 10.884 3.17126 10.611C3.05818 10.3381 2.99999 10.0455 2.99999 9.75C2.99999 9.15326 3.23704 8.58097 3.65899 8.15901C4.08095 7.73705 4.65325 7.5 5.24999 7.5C5.84672 7.5 6.41902 7.73705 6.84098 8.15901C7.26293 8.58097 7.49999 9.15326 7.49999 9.75Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FolderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.75003 9.776C3.86203 9.759 3.97703 9.75 4.09403 9.75H19.906C20.023 9.75 20.138 9.759 20.25 9.776M3.75003 9.776C3.16479 9.86663 2.63888 10.1843 2.28638 10.6602C1.93387 11.1361 1.78319 11.7318 1.86703 12.318L2.72403 18.318C2.80057 18.8541 3.06792 19.3447 3.47701 19.6996C3.88609 20.0545 4.40945 20.2499 4.95103 20.25H19.05C19.5916 20.2499 20.115 20.0545 20.524 19.6996C20.9331 19.3447 21.2005 18.8541 21.277 18.318L22.134 12.318C22.2179 11.7318 22.0672 11.1361 21.7147 10.6602C21.3622 10.1843 20.8353 9.86663 20.25 9.776M3.75003 9.776L3.75103 6C3.75103 5.40344 3.98794 4.83129 4.40968 4.40936C4.83142 3.98744 5.40346 3.75027 6.00003 3.75H9.87903C10.2767 3.75035 10.658 3.90862 10.939 4.19L13.061 6.31C13.3421 6.59138 13.7233 6.74965 14.121 6.75H18C18.5968 6.75 19.1691 6.98705 19.591 7.40901C20.013 7.83097 20.25 8.40326 20.25 9V9.776"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VeraIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.813 15.904L9 18.75L8.187 15.904C7.97687 15.1689 7.5829 14.4994 7.04226 13.9587C6.50162 13.4181 5.83214 13.0241 5.097 12.814L2.25 12L5.096 11.187C5.83114 10.9769 6.50062 10.5829 7.04126 10.0423C7.5819 9.50162 7.97587 8.83214 8.186 8.097L9 5.25L9.813 8.096C10.0231 8.83114 10.4171 9.50062 10.9577 10.0413C11.4984 10.5819 12.1679 10.9759 12.903 11.186L15.75 12L12.904 12.813C12.1689 13.0231 11.4994 13.4171 10.9587 13.9577C10.4181 14.4984 10.0241 15.1679 9.814 15.903L9.813 15.904ZM18.259 8.715L18 9.75L17.741 8.715C17.5927 8.12159 17.286 7.57962 16.8536 7.14703C16.4212 6.71444 15.8794 6.40749 15.286 6.259L14.25 6L15.286 5.741C15.8794 5.59251 16.4212 5.28556 16.8536 4.85297C17.286 4.42038 17.5927 3.87841 17.741 3.285L18 2.25L18.259 3.285C18.4073 3.87854 18.7142 4.42059 19.1468 4.85319C19.5794 5.28579 20.1215 5.59267 20.715 5.741L21.75 6L20.715 6.259C20.1215 6.40733 19.5794 6.71421 19.1468 7.14681C18.7142 7.57941 18.4073 8.12147 18.259 8.715ZM16.894 20.567L16.5 21.75L16.106 20.567C15.9955 20.2356 15.8094 19.9345 15.5625 19.6875C15.3155 19.4406 15.0144 19.2545 14.683 19.144L13.5 18.75L14.683 18.356C15.0144 18.2455 15.3155 18.0594 15.5625 17.8125C15.8094 17.5655 15.9955 17.2644 16.106 16.933L16.5 15.75L16.894 16.933C17.0045 17.2644 17.1906 17.5655 17.4375 17.8125C17.6845 18.0594 17.9856 18.2455 18.317 18.356L19.5 18.75L18.317 19.144C17.9856 19.2545 17.6845 19.4406 17.4375 19.6875C17.1906 19.9345 17.0045 20.2356 16.894 20.567Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IntegrationsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 7.5L18.75 6.187M21 7.5V9.75M21 7.5L18.75 8.813M3 7.5L5.25 6.187M3 7.5L5.25 8.813M3 7.5V9.75M12 12.75L14.25 11.437M12 12.75L9.75 11.437M12 12.75V15M12 21.75L14.25 20.437M12 21.75V19.5M12 21.75L9.75 20.437M9.75 3.562L12 2.25L14.25 3.563M21 14.25V16.5L18.75 17.813M5.25 17.813L3 16.5V14.25"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AuditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2.71399C9.73574 4.86422 6.72026 6.04357 3.598 5.99999C3.20084 7.20997 2.99898 8.47549 3 9.74899C3 15.341 6.824 20.039 12 21.372C17.176 20.04 21 15.342 21 9.74999C21 8.43999 20.79 7.17899 20.402 5.99899H20.25C17.054 5.99899 14.15 4.75099 12 2.71399Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2507 16.2505L13.7617 13.7615M13.7617 13.7615C14.0751 13.4481 14.3237 13.0761 14.4933 12.6666C14.663 12.2571 14.7502 11.8182 14.7502 11.375C14.7502 10.9318 14.663 10.4929 14.4933 10.0835C14.3237 9.67398 14.0751 9.30192 13.7617 8.98852C13.4483 8.67512 13.0763 8.42652 12.6668 8.25691C12.2573 8.0873 11.8184 8 11.3752 8C10.932 8 10.4931 8.0873 10.0837 8.25691C9.67419 8.42652 9.30213 8.67512 8.98873 8.98852C8.35566 9.62159 8 10.4802 8 11.3755C8 12.2708 8.35566 13.1294 8.98873 13.7625C9.6218 14.3956 10.4804 14.7512 11.3757 14.7512C12.271 14.7512 13.1297 14.3956 13.7627 13.7625L13.7617 13.7615Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.879 7.519C11.05 6.494 12.95 6.494 14.121 7.519C15.293 8.544 15.293 10.206 14.121 11.231C13.918 11.41 13.691 11.557 13.451 11.673C12.706 12.034 12.001 12.672 12.001 13.5V14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12ZM12 17.25H12.008V17.258H12V17.25Z"
      stroke="#454545"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DrawerVera = styled(Grid)`
  background: var(--Neutral-Neutral-50, #fafafa);
  padding-left: 20px;
  padding-right: 20px;
`;

const Title = styled(Typography)`
  color: var(--Neutral-Neutral-800, #454545);
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 20px;
  padding-left: 20px;
  width: 100%;
`;

const ButtonDocument = styled(Button)`
  color: #fff;
  display: flex;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 48px;
  padding: 15px 10px;
  width: 100%;
`;

const ContainerMainElements = styled(Grid)`
  margin-top: 20px;
`;

const TextItem = styled(Typography)`
  color: var(--Neutral-Neutral-900, #242424);
  display: flex;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
`;

export default function ClippedDrawer() {
  const [selected, setSelected] = useState('Documents');

  const goToCreate = useCallback(() => {
    navigate('/signables/create');
    setSelected('Documents');
  }, []);

  const mainOptions = [
    {
      text: 'Documents',
      icon: <DocumentsIcon />,

      onClick: () => {
        navigate('/certificates');
      },
    },
    {
      text: 'Archives',
      icon: <ArchivesIcon />,
      onClick: () => navigate('/signables/archives'),
    },
    {
      text: 'Teams',
      icon: <TeamsIcon />,
      onClick: () => navigate('/signables/teams'),
    },
    {
      text: 'Folders',
      icon: <FolderIcon />,
      onClick: () => navigate('/signables/folders'),
    },
    { text: 'AI Assistant', icon: <VeraIcon />, onClick: goToCreate },
  ];

  const secondaryOptions = [
    {
      text: 'Integrations',
      icon: <IntegrationsIcon />,
      onClick: () => navigate('/signables/integrations'),
    },
    {
      text: 'Audit logs',
      icon: <AuditIcon />,
      onClick: () => navigate('/signables/audit'),
    },
    {
      text: 'Support',
      icon: <SupportIcon />,
      onClick: () => navigate('/signables/support'),
    },
  ];

  return (
    <DrawerVera container justify="space-between">
      <Grid
        item
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 'inherit',
          position: 'relative',
          width: '100%',
        }}
        alignItems="flex-start"
      >
        <Toolbar />
        <Title>Dashboard</Title>
        <ButtonDocument
          variant="contained"
          color="primary"
          size="large"
          startIcon={<DocIcon />}
          style={{ borderRadius: 4 }}
          onClick={goToCreate}
        >
          Send Document
        </ButtonDocument>
        <Divider
          style={{ marginTop: '30px', width: '100%', color: '#CBCBCB' }}
        />
        <ContainerMainElements container item>
          <List style={{ width: '100%' }}>
            {mainOptions.map(element => (
              <ListItem
                button
                key={element.text}
                onClick={() => {
                  setSelected(element.text);

                  // eslint-disable-next-line no-unused-expressions, babel/no-unused-expressions
                  element?.onClick();
                }}
                style={{
                  marginTop: '24px',
                  paddingLeft: '30px',
                  display: 'flex',
                  width: '100%',
                }}
              >
                {element.text === selected && (
                  <div style={{ position: 'absolute', left: 20 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                    >
                      <circle cx="4" cy="4" r="4" fill="#00277A" />
                    </svg>
                  </div>
                )}
                <ListItemIcon
                  style={{
                    marginRight: '-10px',
                    marginLeft: element.text === selected ? '20px' : '10px',
                  }}
                >
                  {element.icon}
                </ListItemIcon>
                <TextItem>{element.text}</TextItem>
              </ListItem>
            ))}
          </List>
        </ContainerMainElements>
      </Grid>

      <Grid
        container
        style={{ marginBottom: '10%' }}
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <List style={{ width: '100%' }}>
          <Divider
            style={{ marginTop: '30px', width: '100%', color: '#CBCBCB' }}
          />
          {secondaryOptions.map(element => (
            <ListItem
              button
              key={element.text}
              style={{ marginTop: '30px' }}
              onClick={() => {
                setSelected(element.text);

                // eslint-disable-next-line no-unused-expressions, babel/no-unused-expressions
                element?.onClick();
              }}
            >
              {element.text === selected && (
                <div style={{ position: 'absolute', left: 20 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <circle cx="4" cy="4" r="4" fill="#E3156A" />
                  </svg>
                </div>
              )}
              <ListItemIcon
                style={{
                  marginRight: '-10px',
                  marginLeft: element.text === selected ? '20px' : '10px',
                }}
              >
                {element.icon}
              </ListItemIcon>
              <TextItem>{element.text}</TextItem>
            </ListItem>
          ))}
        </List>
      </Grid>
    </DrawerVera>
  );
}
